import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import Loader from "../../../components/common/Loader";
import Calendar from "../../../components/Calendar/Calendar";
import DashboardMasterclassesList from "./DashboardMasterclassesList";
import {MasterClassService} from "../../../services/masterClassService/masterClassService";
import DashboardAnnouncements from "./DashboardAnnouncements";
import {useNavigate} from "react-router-dom";
import {welcomeVideoService} from "../../../services/authService/welcomeVideoService";
import RecordedVideoSession from "./RecordedVideoSession";

const SpeakerDashboard = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [videoUrl, setVideoUrl] = useState(null);

    const [state, setState] = useState({
        loader: false,
    });

    const [masterClasses, setMasterClasses] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setIsLoading(true);
        getAllMasterClasses();
        getVideoLink();
    }, []);

    const getAllMasterClasses = async () => {
        try {
            const response = await MasterClassService.getSpeakerMasterClasses(1);

            setMasterClasses(response?.data.data);

            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    const getVideoLink = async () => {
        try {
            const response = await welcomeVideoService.getWelcomeVideoUrl('dashboard');
            setVideoUrl(response.data);
        } catch (error) {
            console.log('error during getting welcome video');
            setVideoUrl(null);
        }
    };

    return (
        <>
            {state?.loader || isLoading ? (
                <Loader />
            ) : (
                <>
                    <div className="container-fluid dashboard-content">
                        <div className="row mb-5">
                            <DashboardAnnouncements />
                            <div className="col-md-6 mb-4 mb-md-0">
                                <h1>Driving Educational Growth with Expert Training</h1>
                                <span className="fs-5 text-second fs-lg-4">
                                   Paxton/Patterson provides educational institutions with highly impactful professional development master courses featuring influential thought leaders, subject matter experts, and insightful coaching. We ignite a tipping point that advances institutional culture forward faster.
                                </span>
                                <div className="d-flex mt-3">
                                    <button
                                        className="btn btn-primary-info py-2 px-3"
                                        onClick={() => navigate('/master-classes')}
                                    >
                                        Learn More
                                    </button>
                                </div>
                            </div>

                            <div className="col-md-6 text-center">
                                {videoUrl
                                    ? <div className="master-class__image">
                                        <RecordedVideoSession video={videoUrl}/>
                                    </div>
                                    : <Loader />
                                }
                            </div>
                        </div>
                        <div className="single-lesson-grid">
                            <div className="py-3">
                                <DashboardMasterclassesList
                                    masterClasses={masterClasses}
                                />
                            </div>
                            <div className="py-3">
                                <h3>Events</h3>
                                <div className="card-layout-calendar">
                                    <Calendar/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default SpeakerDashboard;